import { Component } from '@angular/core';

@Component({
  selector: 'app-csr',
  templateUrl: './csr.component.html',
  styleUrl: './csr.component.scss'
})
export class CsrComponent {
  docsItems = [
    { title: ' إرسال مستندات لإتمام الخدمات', image: 'assets/allServices/carouselsec.jpg' },

  ];
  
}
